export default "__VITE_ASSET__dc0fb25d__"